



















































import Vue from "vue";
import { CustomPackage } from "../types";
import isNil from "lodash/isNil";
import SystemPackage from "./SystemPackage.vue";

export default Vue.extend({
  extends: SystemPackage,

  props: {
    thePackage: {
      type: Object as () => CustomPackage
    }
  },

  computed: {
    isUserCreated(): boolean {
      return this.thePackage.user_created;
    },

    isActive(): boolean {
      // @ts-ignore-next-line
      return this.thePackage.required || this.isUserCreated || this.hasRate;
    },

    fieldBasename(): string {
      return "custom_packages";
    }
  },

  methods: {
    updateDescription(description: string) {
      this.$emit("input", { ...this.thePackage, description });
    },

    updateDuration(duration: string) {
      this.$emit("input", {
        ...this.thePackage,
        duration: Number(duration) || null
      });
    }
  }
});
